export { default } from './SimpleInfo';
